import { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import Home from './Home'
import { useDispatch } from 'react-redux'
import { operations } from '../../../../redux/Navigation'
import { useNavigate } from 'react-router-dom'
import { resetOrderRequest } from "client/utils/RequisitionUtil";
import RequisitionAction from 'Store/Component/Requisition/RequisitionAction'
import { setOrderById } from 'Store/OrderManagement/Order/OrderAction'
import { setIsOrderCanceled } from 'redux/PendingOrder/action'
import TransferAction from 'Store/Component/Transfer/TransferAction';
import { resetAllAssetOrderData } from "client/utils/AssetUtil";
import { AlertNotificationDispatch } from "Store/AlertNotification/AlertNotificationDispatch";
import userProfileSelectors from '../../../../redux/UserProfile/selectors'
import orderDispatch from "Store/OrderManagement/Order/OrderDispatch";
import { AlertNotificationDispatch as myAlertNotificationDispatch} from "Store/AlertNotification/AlertNotificationDispatch";

const HomeContainer = () => {
  const [showOrderTypePopup, setShowOrderTypePopup] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const hidePopup = () => {
    setShowOrderTypePopup(false)
  }
  let dispatch = useDispatch();
  let navigate = useNavigate();
  const navDispatch = operations.dispatchNav(dispatch); 
  const dispatchGetMyAlertNotificationDetails = AlertNotificationDispatch.dispatchGetMyAlertNotificationDetails(dispatch);
  const dispatchSetIsAlertNotificationApiCalled = myAlertNotificationDispatch.dispatchSetIsAlertNotificationApiCalled(dispatch);
  const dispatchGetCartCount = orderDispatch.dispatchGetCartCount(dispatch);
  const [showGridPanel, setshowGridPanel] = useState(false);

  const {isAlertNotificationApiCalled, userDetails, myAlertDetails, myNotificationDetails }: any = useSelector(
    (state: any) => ({
      isAlertNotificationApiCalled: state.AlertAndNotificationsReducer.isAlertNotificationApiCalled,
      userDetails: userProfileSelectors.getUserDetails(state),
      myAlertDetails: state.AlertAndNotificationsReducer.myAlertNotificationDetails,
      myNotificationDetails:state.AlertAndNotificationsReducer.myAlertNotificationDetails,
    })
  );

  useEffect(() => {
    if(showGridPanel){
      dispatchGetMyAlertNotificationDetails(userDetails?.userId)
      dispatchSetIsAlertNotificationApiCalled(true);
    }
  },[showGridPanel])

  useEffect (() => {
    function handleResize() {
      const ResizeWidth = window.innerWidth;
      if(ResizeWidth < 769) {
        setshowGridPanel(true);
      }
      else{
        setshowGridPanel(false);
      }
    }
    handleResize();
    window.addEventListener('resize',handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const CreateNewRequisitionHandleClick = () => {
    resetOrderRequest(dispatch);
    dispatch(RequisitionAction.setIsEditRequestClick(false))
    dispatch(RequisitionAction.setEditRequestDetails({}))
    dispatch(RequisitionAction.setIsChangesOccured(false))
    dispatch(TransferAction.setIsChangesOccuredInCart(false))
    dispatch(RequisitionAction.setIsEditOrder(false))
    dispatch(setOrderById(""));
    dispatch(setIsOrderCanceled(""));
    navigate('/ordermanagement/createorder')
  }

  const CreateNewRequestHandleClick = () => {
    dispatch(TransferAction.setTransferOrderDetails({}));
    resetAllAssetOrderData(dispatch)
    dispatch(TransferAction.setIsEditOrder(false));
    navigate('/ordermanagement/assetcreateorder')
    dispatch(RequisitionAction.setIsChangesOccured(false))
    dispatch(TransferAction.setIsChangesOccuredInCart(false))
  }

  const setModalDisplay = (data: boolean) => {
    setShowModal(data);
  }
  const breadcrumlist = [
    { text: 'Home', key: 'f1', href: '/Home', onClick: (e: any) => { e.preventDefault(); navDispatch('Home') } }, {}
  ]
  const [Popupcontent, setPopupcontent] = useState<any>({
    title: "",
    isDialogVisible: false,
    isTitleWarning: false,
    subtextcontent: "",
    primaryBtnText: "",
    outlineBtnText: "",
    isSingleConfirmationBtn: false,
    isCommentboxVisible: false,
    isCompletedReportVisible: false,
    titleImg: "",
    isCommentBoxRequire: false,
    outlineBtnnavigateTo: "",
    primaryBtnnavigateTo: "",
    actionby: "",
    value: 0,
    comments: "",
  });

  const wrapperRef = useRef<any>(null);

  useEffect(() => {    
    if(isAlertNotificationApiCalled && userDetails?.userId){
      dispatchGetMyAlertNotificationDetails(userDetails?.userId);
      dispatchGetCartCount(userDetails?.emailId)
    }  
  }, []);

  const hidePanel = () => {
    setshowGridPanel(false);
  }
  
  const showPanel = () => {
    setshowGridPanel(true);
  }

  return <Home showPanel = {showPanel} hidePanel = {hidePanel} showGridPanel = {showGridPanel} myNotificationDetails = {myNotificationDetails} myAlertDetails = {myAlertDetails} wrapperRef={wrapperRef} CreateNewRequisitionHandleClick={CreateNewRequisitionHandleClick} showOrderTypePopup={showOrderTypePopup} hidePopup={hidePopup} setModalDisplay={setModalDisplay} showModal={showModal} breadcrumlist={breadcrumlist} Popupcontent={Popupcontent} CreateNewRequestHandleClick={CreateNewRequestHandleClick}/>
}

export default HomeContainer
